import { GetAddressUseCase } from '../../../application';

export default class GetAddressServices {
    constructor() {}

    async execute(event) {
        const request = await GetAddressUseCase(event);

        return request;
    }
}
